import { Component, computed, input } from '@angular/core';
import { IntegracaoLog } from '../../core/models/integracao.model';

/** Uma parcela da carga. As três somadas dão o total de registros. */
interface ResumoSegmento {
  chave: 'pendentes' | 'integrados' | 'erros';
  rotulo: string;
  valor: number;
  percentual: number;
}

@Component({
  selector: 'app-integracao-resumo-carga',
  templateUrl: './integracao-resumo-carga.component.html',
  styleUrl: './integracao-resumo-carga.component.scss',
})
export class IntegracaoResumoCargaComponent {
  readonly resumo = input.required<IntegracaoLog>();

  readonly segmentos = computed<ResumoSegmento[]>(() => {
    const { total, pendentes, integrados, erros } = this.resumo();
    const percentual = (valor: number) => (total > 0 ? Math.round((valor / total) * 100) : 0);

    return [
      {
        chave: 'pendentes',
        rotulo: 'Pendentes de integração',
        valor: pendentes,
        percentual: percentual(pendentes),
      },
      {
        chave: 'integrados',
        rotulo: 'Integrados',
        valor: integrados,
        percentual: percentual(integrados),
      },
      {
        chave: 'erros',
        rotulo: 'Erros',
        valor: erros,
        percentual: percentual(erros),
      },
    ];
  });

  readonly cargaVazia = computed(() => this.resumo().total === 0);
}
